import { __decorate, __metadata } from 'tslib';
import { NgModule } from '@angular/core';
import { NbIconLibraries, NbSvgIcon } from '@nebular/theme';
import { icons } from 'eva-icons';

/*
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@nebular/theme';
class NbEvaSvgIcon extends NbSvgIcon {
    constructor(name, content) {
        super(name, '');
        this.name = name;
        this.content = content;
    }
    getContent(options) {
        return this.content.toSvg(Object.assign({ width: '100%', height: '100%', fill: 'currentColor' }, options));
    }
}
let NbEvaIconsModule = class NbEvaIconsModule {
    constructor(iconLibrary) {
        this.NAME = 'eva';
        iconLibrary.registerSvgPack(this.NAME, this.createIcons());
        iconLibrary.setDefaultPack(this.NAME);
    }
    createIcons() {
        return Object
            .entries(icons)
            .map(([name, icon]) => {
            return [name, new NbEvaSvgIcon(name, icon)];
        })
            .reduce((newIcons, [name, icon]) => {
            newIcons[name] = icon;
            return newIcons;
        }, {});
    }
};
NbEvaIconsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NbEvaIconsModule });
NbEvaIconsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function NbEvaIconsModule_Factory(t) { return new (t || NbEvaIconsModule)(ɵngcc0.ɵɵinject(ɵngcc1.NbIconLibraries)); } });
NbEvaIconsModule = __decorate([ __metadata("design:paramtypes", [NbIconLibraries])
], NbEvaIconsModule);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NbEvaIconsModule, [{
        type: NgModule,
        args: [{}]
    }], function () { return [{ type: ɵngcc1.NbIconLibraries }]; }, null); })();

/*
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NbEvaSvgIcon, NbEvaIconsModule };

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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